import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { BaseLetterGenerationEntryLibraryService } from 'base-letter-generation-entry-library';
import * as i1 from '@ngrx/store';
import * as i2 from 'app-services-library';
import * as i3 from 'primeng/radiobutton';
import * as i4 from '@angular/forms';
import { PrimengLibraryModule } from 'primeng-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { DigitalSignatureLibraryModule } from 'digital-signature-library';

class LetterGenerationEntryLibraryService {
    constructor() { }
}
LetterGenerationEntryLibraryService.ɵfac = function LetterGenerationEntryLibraryService_Factory(t) { return new (t || LetterGenerationEntryLibraryService)(); };
LetterGenerationEntryLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LetterGenerationEntryLibraryService, factory: LetterGenerationEntryLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterGenerationEntryLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LetterGenerationEntryLibraryComponent extends BaseLetterGenerationEntryLibraryService {
    constructor(store, appServicesLibraryService) {
        super(store, appServicesLibraryService);
        this.store = store;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        this.inputData = this.primaryData;
        this.docType = 'COVLTR';
        super.loadInit();
    }
    handleClose() {
        this.onDialogClose.emit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
LetterGenerationEntryLibraryComponent.ɵfac = function LetterGenerationEntryLibraryComponent_Factory(t) { return new (t || LetterGenerationEntryLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService)); };
LetterGenerationEntryLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LetterGenerationEntryLibraryComponent, selectors: [["letter-generation-entry-library"]], inputs: { primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 6, consts: [[1, "fluid-container", "col-md-12", "col-lg-12", "pr-0", "entry-class"], [1, "row", "col-md-12", "pl-0", "pt-3"], ["name", "coverLetterType", "label", "Select Predefined Template", 1, "letter-radio", 3, "disabled", "value", "ngModel", "onClick", "ngModelChange"], ["name", "coverLetterType", "label", "Create Own Letter", 1, "letter-radio", 3, "disabled", "ngModel", "value", "onClick", "ngModelChange"]], template: function LetterGenerationEntryLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelementStart(2, "Span");
        i0.ɵɵtext(3, " Would you like to select a pre-defined template or create your own Letter to generate Cover Letter? ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 1);
        i0.ɵɵelementStart(5, "p-radioButton", 2);
        i0.ɵɵlistener("onClick", function LetterGenerationEntryLibraryComponent_Template_p_radioButton_onClick_5_listener() { return ctx.handleSelection(); })("ngModelChange", function LetterGenerationEntryLibraryComponent_Template_p_radioButton_ngModelChange_5_listener($event) { return ctx.templateValue = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "p-radioButton", 3);
        i0.ɵɵlistener("onClick", function LetterGenerationEntryLibraryComponent_Template_p_radioButton_onClick_6_listener() { return ctx.handleSelection(); })("ngModelChange", function LetterGenerationEntryLibraryComponent_Template_p_radioButton_ngModelChange_6_listener($event) { return ctx.templateValue = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("value", 0)("ngModel", ctx.templateValue);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("ngModel", ctx.templateValue)("value", 1);
    } }, directives: [i3.RadioButton, i4.NgControlStatus, i4.NgModel], styles: [".entry-class[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:15px}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterGenerationEntryLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'letter-generation-entry-library',
                templateUrl: 'letter-generation-entry-library.component.html',
                styleUrls: ['letter-generation-entry-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class LetterGenerationEntryLibraryModule {
}
LetterGenerationEntryLibraryModule.ɵfac = function LetterGenerationEntryLibraryModule_Factory(t) { return new (t || LetterGenerationEntryLibraryModule)(); };
LetterGenerationEntryLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LetterGenerationEntryLibraryModule });
LetterGenerationEntryLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseLetterGenerationEntryLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            DigitalSignatureLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LetterGenerationEntryLibraryModule, { declarations: [LetterGenerationEntryLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        DigitalSignatureLibraryModule], exports: [LetterGenerationEntryLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LetterGenerationEntryLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LetterGenerationEntryLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    DigitalSignatureLibraryModule
                ],
                providers: [BaseLetterGenerationEntryLibraryService],
                exports: [LetterGenerationEntryLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of letter-generation-entry-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LetterGenerationEntryLibraryComponent, LetterGenerationEntryLibraryModule, LetterGenerationEntryLibraryService };
//# sourceMappingURL=letter-generation-entry-library.js.map
